import Link from 'next/link';
import { BUTTON_COLOR_HOVER } from '../../constants';

export const ButtonLogIn = () => {
  return (
    <Link
      href="/auth/login"
      className={`block w-full text-left text-sm text-gray-400 hover:text-white px-4 py-2 ${BUTTON_COLOR_HOVER} transition-colors rounded-md`}
    >
      Log in
    </Link>
  );
};
